import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { FiChevronDown } from "react-icons/fi";
import { TiSocialGooglePlus, TiSocialFacebook } from "react-icons/ti";
import validator from 'validator';

import { navProperty } from '../../data/data';

import logo from '../../assets/img/logo.png'
import users from '../../assets/img/svg/users.svg'
import addImg from '../../assets/img/svg/add.svg'
import bar from '../../assets/img/svg/bar.svg'
import loginImg from '../../assets/img/svg/login.svg'
import { deleteAccount, editProfile, loginUser } from '../../services/ApiServices';
import toast from 'react-hot-toast';
import CreateAccount from '../../pages/admin/create-account';
import ForgotPassword from '../../pages/admin/forgot-password';
import OtpModal from '../../pages/admin/otp';
import ResetPassword from '../../pages/admin/reset-password';

export default function Navbar({ transparent }: { transparent: any }) {
    const navigate = useNavigate();
    const userProfileString = localStorage?.getItem('userProfile');
    const userDetail: any = userProfileString ? JSON.parse(userProfileString) : null;

    console.log("userDetail", userDetail);
    const initialEditProfile = {
        userName: "",
        address: "",
        phoneNumber: "",
        email: "",
        type: ""
    }

    const [activeMenu, setActiveMenu] = useState<{ [key: string]: { [key: string]: boolean }; }>({});
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [toggle, setIsToggle] = useState<boolean>(false);
    const [login, setLogin] = useState<boolean>(false);
    const [createAccount, setCreateAccount] = useState<boolean>(false);
    const [isEditable, setEditable] = useState<boolean>(false);
    const [deleteAccModal, setDeletAccModal] = useState<boolean>(false);
    const [logOutModal, setLogOutModal] = useState<boolean>(false);
    const [property, setProperty] = useState<boolean>(false);
    const [activeTab, setActiveTab] = useState<number>(1);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [isOpenWarn, setOpenWarn] = useState<boolean>(false);
    const [isOpenMySpaceWarn, setOpenMySpaceWarn] = useState<boolean>(false);
    const [editProfileDetails, setEditProfileDetails] = useState<any>(initialEditProfile);
    const [image, setImage] = useState<any>("");
    const [profileImage, setProfileImage] = useState<any>("");
    const [forgotEmailId, setForgotEmailId] = useState<any>("");
    const [isOpenForgotPwd, setOpenForgotPwd] = useState<boolean>(false);
    let [scroll, setScroll] = useState<boolean>(false);
    const [isOpenOTP, setOpenOTP] = useState<boolean>(false);
    const [isOpenResetPwd, setOpenResetPwd] = useState<boolean>(false);
    const [otp, setOTP] = useState<string>("");
    console.log("activeMenu", activeMenu);

    const location = useLocation();
    const current = location.pathname

    const handleMouseEnter = (menu: string, submenu?: string) => {
        setActiveMenu((prev) => ({
            ...prev,
            [menu]: {
                ...prev[menu],
                [submenu || 'main']: true, // Open main menu or submenu
            },
        }));
    };

    // Handle mouse leave for any menu or submenu
    const handleMouseLeave = (menu: string, submenu?: string) => {
        setActiveMenu((prev) => ({
            ...prev,
            [menu]: {
                ...prev[menu],
                [submenu || 'main']: false, // Close main menu or submenu
            },
        }));
    };

    useEffect(() => {
        window.scrollTo(0, 0)

        const handlerScroll = () => {
            if (window.scrollY > 50) {
                setScroll(true)
            } else { setScroll(false) }
        }

        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('scroll', handlerScroll)
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('scroll', handlerScroll)
            window.removeEventListener('resize', handleResize);
        };
    }, [windowWidth])

    useEffect(() => {
        if (userDetail) {
            setEditProfileDetails({
                userName: userDetail.username,
                address: userDetail.address,
                phoneNumber: userDetail.phoneno,
                email: userDetail.email,
                type: userDetail.type
            })
        }
    }, [])

    const loginUserApiCall = () => {
        // e.preventDefault()
        setLoading(true)
        const data = new FormData();

        data.append('email', email);
        data.append('password', password);
        loginUser(data).then((res) => {
            console.log("get login response", res);

            if (res?.status === "success") {
                setLoading(false)
                const profile: any = res
                console.log("login---------->", profile);
                setLogin(false)
                localStorage?.setItem('userProfile', JSON.stringify(res.userdata));
                localStorage?.setItem('api_token', res.token);
                toast.success(profile.message);
                setPassword("");
                setEmail("");
                window.location.reload();
            } else if (res?.status === "error") {
                toast.error(res?.message)
                setLoading(false)
            }
        }).catch((err) => {
            console.log("login error---------->", err);
            toast.error(err?.response?.data?.message)
        })
    }

    const handleLogout = () => {
        localStorage.removeItem('api_token');
        localStorage.removeItem('userProfile');
        window.location.reload();
        toast.success("Logged out successfully!");
        setLogOutModal(false)
        navigate("/")
    }

    const handleDeleteAccount = () => {
        deleteAccount().then((res) => {
            console.log("get login response", res);

            if (res?.status === "success") {
                const profile = res
                console.log("login---------->", profile);
                setDeletAccModal(false)
                localStorage?.removeItem('userProfile');
                localStorage?.removeItem('api_token');
                toast.success(profile.message);
            } else {
                toast.error("Something went wrong")
            }
        })
    }

    const handlePostProperty = () => {
        if (userDetail) {
            console.log("render if ")
            navigate("/add-space")
        } else {
            setOpenWarn(true)
        }
    }

    const handleMySpace = (e: any) => {
        e.preventDefault();
        if (userDetail) {
            console.log("render if ===>")
            navigate("/my-space")
        } else {
            setOpenMySpaceWarn(true)
        }
    }

    const editProfileAPICall = () => {
        // e.preventDefault()
        const data = new FormData();

        data.append('username', editProfileDetails?.userName);
        data.append('phoneno', editProfileDetails?.phoneNumber);
        if (editProfileDetails?.address) {
            data.append('address', editProfileDetails?.address)
        }
        data.append('type', editProfileDetails?.type);
        if (profileImage) {
            data.append('image', profileImage);
        }
        editProfile(data).then((res) => {
            console.log("edit profile response", res);

            if (res?.status === "success") {
                const profile = res
                console.log("login---------->", profile);
                if (res?.validate_error === 1) {
                    toast.error(res?.message)
                    return;
                } else if (res?.validate_error === 0) {
                    localStorage?.setItem('userProfile', JSON.stringify(res.userdata));
                    localStorage?.setItem('api_token', res.token);
                    toast.success(res?.message);
                    setEditable(false);
                    setEditProfileDetails(initialEditProfile)
                    window.location.reload();
                }
            } else {
                toast.error("Something went wrong")
            }
        }).catch((err) => {
            console.log("edit profile error---------->", err);
        });
    }

    const editValidation = (e: any) => {
        e.preventDefault();
        if (!editProfileDetails?.userName) {
            toast.error("Please enter a user name")
            return;
        }
        if (!editProfileDetails?.phoneNumber) {
            toast.error("Please enter a phone number")
            return;
        }
        if (!editProfileDetails?.email) {
            toast.error("Please enter email address")
            return;
        }
        if (editProfileDetails?.email && !validator.isEmail(editProfileDetails?.email)) {
            toast.error("Please enter a valid email")
            return;
        }
        if (!editProfileDetails?.type) {
            toast.error("Please select a user type")
            return;
        }
        editProfileAPICall()
    }

    const handleEditProfile = (e: any) => {
        setEditProfileDetails({ ...editProfileDetails, [e.target.name]: e.target.value })
    }

    const handleUploadImageChange = (event: any) => {
        console.log("event", event?.target?.files);

        const fileObj = event.target.files && URL.createObjectURL(event.target.files[0]);
        if (!fileObj) {
            return;
        } else {
            setProfileImage(event.target.files[0])
            setImage(fileObj)
        }
    };

    return (
        <>
            <div className={`header ${scroll ? 'header-fixed' : ''} ${transparent ? 'header-transparent dark' : 'header-light head-shadow'}`} style={{ zIndex: 1100 }}>
                <div className="container">
                    <nav id="navigation " className={windowWidth > 991 ? "navigation navigation-landscape" : "navigation navigation-portrait"} >
                        <div className="nav-header" style={{ lineHeight: '0', padding: 13 }}>
                            <Link className="nav-brand" to="/" >
                                <div ><img src={logo} style={{}} /></div>
                                {/* <h5 className="fs-3 fw-bold ms-1 my-0 align-center" style={{ color: "#AFABAB" }}>Commercial<span style={{ color: "#00B050" }}>SPC</span><sup style={{ color: "#000" }}>SM</sup></h5> */}
                            </Link>
                            <div className="nav-toggle" onClick={() => setIsToggle(!toggle)}></div>
                            <div className="mobile_nav">
                                <ul>
                                    <li>
                                        {/* <Link to="#" onClick={() => setLogin(!login)}> */}
                                        {/* <img src={users} alt="" /> */}
                                        {userDetail ?
                                            <li className={`${['logout'].includes(current) ? 'active' : ''} ${activeMenu['logout']?.main ? 'show' : ''}`} onMouseEnter={() => handleMouseEnter('logout')} onMouseLeave={() => handleMouseLeave('logout')}>
                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#login" className="fw-medium text-muted-2" >
                                                    {userDetail?.image ?
                                                        <img src={userDetail?.image} style={{ borderRadius: 50, height: 30, width: 30, marginRight: 5 }} />
                                                        : <img src={users} alt="" />}
                                                </Link>
                                                <ul className="nav-dropdown nav-submenu" style={{ display: activeMenu['logout']?.main ? 'block' : 'none', pointerEvents: activeMenu['logout']?.main ? 'auto' : 'none', }}>
                                                    <li
                                                        className={['/agents'].includes(current) ? 'active' : ''}
                                                        onClick={() => {
                                                            setEditable(true)
                                                        }}
                                                    ><Link to="#">Edit Profile</Link>
                                                    </li>
                                                    <li
                                                        className={['/single-property-1'].includes(current) ? 'active' : ''}
                                                        onClick={() => setLogOutModal(true)}
                                                    >
                                                        <Link to="#">Log Out</Link>
                                                    </li>
                                                    <li
                                                        className={['/agents'].includes(current) ? 'active' : ''}
                                                        onClick={() => setDeletAccModal(true)}
                                                    ><Link to="#">Delete Account</Link>
                                                    </li>

                                                </ul>
                                            </li> :
                                            <Link to="#" onClick={() => setLogin(!login)}>
                                                <img src={users} alt="" />
                                            </Link>
                                        }
                                    </li>
                                    <li>
                                        <Link to={userDetail ? "/add-space" : "#"} className="text-primary" onClick={() => handlePostProperty()}>
                                            <img src={addImg} alt="" />
                                        </Link>
                                    </li>
                                    {/* <li>
                                        <Link to="#" className="text-primary" onClick={() => setProperty(!property)}>
                                            <img src={bar} alt="" />
                                        </Link>
                                    </li> */}
                                </ul>
                            </div>
                        </div>
                        <div className={`nav-menus-wrapper  ${toggle ? 'nav-menus-wrapper-open' : ''}`} style={{ transitionProperty: toggle ? 'none' : 'left' }}>
                            <span className="nav-menus-wrapper-close-button" onClick={() => setIsToggle(!toggle)}>✕</span>
                            <ul className="nav-menu" >

                                <li className={`${['/'].includes(current) ? 'active' : ''} ${activeMenu['home']?.main ? 'show' : ''}`} onMouseEnter={() => handleMouseEnter('home')} onMouseLeave={() => handleMouseLeave('home')}><Link to="/">Home</Link>
                                </li>
                                <li className={` ${['/how-it-works'].includes(current) ? 'active' : ''} ${activeMenu['howItWork']?.main ? 'show' : ''}`} onMouseEnter={() => handleMouseEnter('howItWork')} onMouseLeave={() => handleMouseLeave('howItWork')}><Link to="/how-it-works">How it works</Link>
                                </li>
                                <li className={` ${['/list-layout-one', '/grid-layout-with-sidebar'].includes(current) ? 'active' : ''} ${activeMenu['listing']?.main ? 'show' : ''}`} onMouseEnter={() => handleMouseEnter('listing')} onMouseLeave={() => handleMouseLeave('listing')}><Link to="/list-layout-one">Properties</Link>
                                </li>

                                <li className={`${['/my-space'].includes(current) ? 'active' : ''} ${activeMenu['pages']?.main ? 'show' : ''}`} onMouseEnter={() => handleMouseEnter('pages')} onMouseLeave={() => handleMouseLeave('pages')}><Link to="#" onClick={(e) => handleMySpace(e)}>My Space</Link></li>
                                <li className={`${['/pricing'].includes(current) ? 'active' : ''} ${activeMenu['pages']?.main ? 'show' : ''}`} onMouseEnter={() => handleMouseEnter('pages')} onMouseLeave={() => handleMouseLeave('pages')}><Link to="/pricing">Pricing</Link></li>
                                <li className={`${['/free-ad'].includes(current) ? 'active' : ''} ${activeMenu['pages']?.main ? 'show' : ''}`} onMouseEnter={() => handleMouseEnter('pages')} onMouseLeave={() => handleMouseLeave('pages')}><Link to="/free-ad">Free Ad</Link></li>
                                <li className={`${['/contact'].includes(current) ? 'active' : ''} ${activeMenu['pages']?.main ? 'show' : ''}`} onMouseEnter={() => handleMouseEnter('pages')} onMouseLeave={() => handleMouseLeave('pages')}><Link to="/contact">Contact</Link></li>
                                <li className={`${['/faq'].includes(current) ? 'active' : ''} ${activeMenu['pages']?.main ? 'show' : ''}`} onMouseEnter={() => handleMouseEnter('pages')} onMouseLeave={() => handleMouseLeave('pages')}><Link to="/faq">FAQ</Link></li>
                            </ul>

                            <ul className="nav-menu nav-menu-social align-to-right d-none d-lg-inline-flex">
                                {userDetail ?
                                    <>
                                        <li className={`${['logout'].includes(current) ? 'active' : ''} ${activeMenu['logout']?.main ? 'show' : ''}`} onMouseEnter={() => handleMouseEnter('logout')} onMouseLeave={() => handleMouseLeave('logout')}>
                                            <Link to="#" data-bs-toggle="modal" data-bs-target="#login" className="fw-medium text-muted-2" >
                                                {!userDetail?.image ?
                                                    <span className="svg-icon svg-icon-2hx me-1">
                                                        <svg width="22" height="22" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor" />
                                                            <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor" />
                                                            <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor" />
                                                        </svg>
                                                    </span> :
                                                    <img src={userDetail?.image} style={{ borderRadius: 50, height: 30, width: 30, marginRight: 5 }} />}

                                                {userDetail?.username}
                                            </Link>
                                            <ul className="nav-dropdown nav-submenu" style={{ display: activeMenu['logout']?.main ? 'block' : 'none', pointerEvents: activeMenu['logout']?.main ? 'auto' : 'none', }}>
                                                <li
                                                    className={['/agents'].includes(current) ? 'active' : ''}
                                                    onClick={() => {
                                                        setEditable(true)
                                                    }}
                                                ><Link to="#">Edit Profile</Link>
                                                </li>
                                                <li
                                                    className={['/single-property-1'].includes(current) ? 'active' : ''}
                                                    onClick={() => setLogOutModal(true)}
                                                >
                                                    <Link to="#">Log Out</Link>
                                                </li>
                                                <li
                                                    className={['/agents'].includes(current) ? 'active' : ''}
                                                    onClick={() => setDeletAccModal(true)}
                                                ><Link to="#">Delete Account</Link>
                                                </li>

                                            </ul>
                                        </li>
                                    </>
                                    :
                                    <li>
                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#login" className="fw-medium text-muted-2" onClick={() => setLogin(!login)}>
                                            <span className="svg-icon svg-icon-2hx me-1">
                                                <svg width="22" height="22" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor" />
                                                    <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor" />
                                                    <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor" />
                                                </svg>
                                            </span>
                                            SignUp  or SignIn
                                        </Link>
                                    </li>
                                }
                                <li className="add-listing">
                                    <Link to={userDetail ? "/add-space" : "#"} className="bg-primary" onClick={() => handlePostProperty()}>
                                        <img src={loginImg} alt="" className='me-1' />Add Property
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="nav-overlay-panel" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', display: toggle ? 'block' : 'none' }}></div>
                    </nav >
                </div >
            </div >
            <div className="clearfix"></div>
            {
                deleteAccModal &&
                <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
                    <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                        <div className="modal-content" id="registermodal">
                            <span className="mod-close" onClick={() => setDeletAccModal(!deleteAccModal)}>
                                <span className="svg-icon text-primary svg-icon-2hx">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                        <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                        <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                    </svg>
                                </span>
                            </span>
                            <div className="modal-body">
                                <h4 className="modal-header-title" style={{ fontSize: 25 }}>Delete Account</h4>
                                <div className="d-flex align-items-center justify-content-center mb-3">
                                    <span>Are you sure you want to delete your account?</span>

                                    {/* <span className="svg-icon text-primary svg-icon-2hx">
                                        <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.8797 15.375C15.9797 15.075 15.9797 14.775 15.9797 14.475C15.9797 13.775 15.7797 13.075 15.4797 12.475C14.7797 11.275 13.4797 10.475 11.9797 10.475C11.7797 10.475 11.5797 10.475 11.3797 10.575C7.37971 11.075 4.67971 14.575 2.57971 18.075L10.8797 3.675C11.3797 2.775 12.5797 2.775 13.0797 3.675C13.1797 3.875 13.2797 3.975 13.3797 4.175C15.2797 7.575 16.9797 11.675 15.8797 15.375Z" fill="currentColor"></path>
                                            <path opacity="0.3" d="M20.6797 20.6749C16.7797 20.6749 12.3797 20.275 9.57972 17.575C10.2797 18.075 11.0797 18.375 11.9797 18.375C13.4797 18.375 14.7797 17.5749 15.4797 16.2749C15.6797 15.9749 15.7797 15.675 15.7797 15.375V15.2749C16.8797 11.5749 15.2797 7.47495 13.2797 4.07495L21.6797 18.6749C22.2797 19.5749 21.6797 20.6749 20.6797 20.6749ZM8.67972 18.6749C8.17972 17.8749 7.97972 16.975 7.77972 15.975C7.37972 13.575 8.67972 10.775 11.3797 10.375C7.37972 10.875 4.67972 14.375 2.57972 17.875C2.47972 18.075 2.27972 18.375 2.17972 18.575C1.67972 19.475 2.27972 20.475 3.27972 20.475H10.3797C9.67972 20.175 9.07972 19.3749 8.67972 18.6749Z" fill="currentColor"></path>
                                        </svg>
                                    </span> */}
                                </div>
                                <div className="form-group d-flex">
                                    <button type="button" className="btn btn-md btn-outline-primary fw-medium full-width rounded-2 me-2" onClick={() => setDeletAccModal(!deleteAccModal)}>Cancel</button>
                                    <button type="button" className="btn btn-md btn-primary fw-medium full-width rounded-2" onClick={() => handleDeleteAccount()}>Delete Account</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                logOutModal &&
                <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
                    <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                        <div className="modal-content" id="registermodal">
                            <span className="mod-close" onClick={() => setLogOutModal(!logOutModal)}>
                                <span className="svg-icon text-primary svg-icon-2hx">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                        <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                        <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                    </svg>
                                </span>
                            </span>
                            <div className="modal-body">
                                <h4 className="modal-header-title" style={{ fontSize: 25 }}>Log Out</h4>
                                <div className="d-flex align-items-center justify-content-center mb-3">
                                    <span>Are you sure you want to log out?</span>
                                </div>
                                <div className="form-group d-flex">
                                    <button type="button" className="btn btn-md btn-outline-primary fw-medium full-width rounded-2 me-2" onClick={() => setLogOutModal(!logOutModal)}>Cancel</button>
                                    <button type="button" className="btn btn-md btn-primary fw-medium full-width rounded-2" onClick={() => handleLogout()}>Log Out</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                isOpenMySpaceWarn &&
                <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
                    <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                        <div className="modal-content" id="registermodal">
                            <span className="mod-close" onClick={() => setOpenMySpaceWarn(!isOpenMySpaceWarn)}>
                                <span className="svg-icon text-primary svg-icon-2hx">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                        <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                        <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                    </svg>
                                </span>
                            </span>
                            <div className="modal-body">
                                <h4 className="modal-header-title" style={{ fontSize: 25 }}>Log In</h4>
                                <div className="d-flex align-items-center justify-content-center mb-3">
                                    <span>Please sign in to see your space</span>
                                </div>
                                <div className="form-group d-flex">
                                    <button type="button" className="btn btn-md btn-outline-primary fw-medium full-width rounded-2 me-2" onClick={() => setOpenMySpaceWarn(!isOpenMySpaceWarn)}>Cancel</button>
                                    <button type="button" className="btn btn-md btn-primary fw-medium full-width rounded-2" onClick={() => {
                                        setLogin(true)
                                        setOpenMySpaceWarn(false)
                                    }}>Login</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                isOpenWarn &&
                <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
                    <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                        <div className="modal-content" id="registermodal">
                            <span className="mod-close" onClick={() => setOpenWarn(!isOpenWarn)}>
                                <span className="svg-icon text-primary svg-icon-2hx">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                        <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                        <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                    </svg>
                                </span>
                            </span>
                            <div className="modal-body">
                                <h4 className="modal-header-title" style={{ fontSize: 25 }}>Log In</h4>
                                <div className="d-flex align-items-center justify-content-center mb-3">
                                    <span>Before you add space you need to login</span>
                                </div>
                                <div className="form-group d-flex">
                                    <button type="button" className="btn btn-md btn-outline-primary fw-medium full-width rounded-2 me-2" onClick={() => setOpenWarn(!isOpenWarn)}>Cancel</button>
                                    <button type="button" className="btn btn-md btn-primary fw-medium full-width rounded-2" onClick={() => {
                                        setLogin(true)
                                        setOpenWarn(false)
                                    }}>Login</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                login &&
                <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
                    <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                        <div className="modal-content" id="registermodal">
                            <span className="mod-close"
                                onClick={() => {
                                    setEmail("")
                                    setPassword("")
                                    setLogin(!login)
                                }}>
                                <span className="svg-icon text-primary svg-icon-2hx">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                        <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                        <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                    </svg>
                                </span>
                            </span>
                            <div className="modal-body">
                                <h4 className="modal-header-title">Log In</h4>
                                <div className="d-flex align-items-center justify-content-center mb-3">
                                    <img src={logo} height={50} width={"40%"} />
                                </div>
                                <div className="login-form">
                                    <form>

                                        <div className="form-floating mb-3">
                                            <input type="email" className="form-control" placeholder="name@example.com" onChange={(e) => setEmail(e.target.value)} value={email} />
                                            <label>Email address</label>
                                        </div>

                                        <div className="form-floating mb-3">
                                            <input type="password" className="form-control" placeholder="Password" onChange={(e) => setPassword(e.target.value)} value={password} />
                                            <label>Password</label>
                                        </div>

                                        <div className="form-group mb-3">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="flex-shrink-0 flex-first">
                                                    <div className="form-check form-check-inline">
                                                        <label className="form-check-label" htmlFor="save-pass"></label>
                                                    </div>
                                                </div>
                                                <div className="flex-shrink-0 flex-first">
                                                    <Link to="#" className="link fw-medium"
                                                        onClick={() => {
                                                            setOpenForgotPwd(true);
                                                            setLogin(false);
                                                        }}>
                                                        Forgot Password?</Link>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <button type="button" className="btn btn-lg btn-primary fw-medium full-width rounded-2" onClick={() => loginUserApiCall()}>{isLoading ? "Loging..." : "LogIn"}</button>
                                        </div>

                                    </form>
                                </div>
                                <div className="text-center">
                                    <p className="mt-4">Don't have an Account? <Link to="#" className="link fw-medium" onClick={() => {
                                        setCreateAccount(true)
                                        setLogin(false)
                                    }}>Create An Account</Link></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {
                isEditable &&
                <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
                    <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                        <div className="modal-content" id="registermodal">
                            <span className="mod-close" onClick={() => setEditable(!isEditable)}>
                                <span className="svg-icon text-primary svg-icon-2hx">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                        <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                        <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                    </svg>
                                </span>
                            </span>
                            <div className="modal-body">
                                <div className="form-header text-center mb-5">
                                    <h4 className="fs-2">Edit Profile</h4>
                                </div>
                                <div className="login-form">
                                    <form>
                                        <div className='form-floating mb-3 d-flex' style={{ justifyContent: "center" }}>
                                            <div className=" dz-clickable primary-dropzone position-relative  w-30 h-30 " style={{ borderRadius: 100 / 2, border: '1px dashed #000', cursor: "pointer" }}>
                                                <div className='position-relative '>
                                                    {profileImage ?
                                                        <img src={image} className='position-relative h-30 w-30 p-1' style={{ borderRadius: 100 / 2 }} /> :
                                                        <div className="dz-default" style={{ display: "flex", flexDirection: "column", justifyContent: "center", padding: 29 }}>
                                                            <i className="fa-solid fa-images" style={{ fontSize: 50 }}></i>
                                                        </div>}
                                                    <input
                                                        type="file"
                                                        style={{ position: "absolute", top: 0, height: 110, opacity: 0 }}
                                                        accept='.png, .jpg,.jpeg'
                                                        onChange={handleUploadImageChange}
                                                        id="profilePhoto"
                                                        className="dz-message dz-default w-100"
                                                        multiple
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-floating mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="John Smith"
                                                name='userName'
                                                onChange={handleEditProfile}
                                                value={editProfileDetails?.userName}
                                            />
                                            <label>Username</label>
                                        </div>
                                        <div className="form-floating mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder='123, Waterfall Street, Irving, Texas'
                                                name='address'
                                                onChange={handleEditProfile}
                                                value={editProfileDetails?.address}
                                            />
                                            <label>Address</label>
                                        </div>
                                        <div className="form-floating mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder='123 456 7898'
                                                name='phoneNumber'
                                                onChange={handleEditProfile}
                                                value={editProfileDetails?.phoneNumber}
                                            />
                                            <label>Phone Number</label>
                                        </div>
                                        <div className="form-floating mb-3">
                                            <input
                                                type="email"
                                                className="form-control"
                                                placeholder="name@example.com"
                                                onChange={handleEditProfile}
                                                value={editProfileDetails?.email}
                                                disabled
                                                style={{ opacity: 0.5 }}
                                            />
                                            <label>Email address</label>
                                        </div>

                                        <div className="form-floating">
                                            <div className="form-group">
                                                <label className='mb-2'>I am a</label>
                                                <select className="form-control" onChange={handleEditProfile} name='type' value={editProfileDetails?.type}>
                                                    <option value={"Owner"}>Owner</option>
                                                    <option value={"Broker"}>Broker</option>
                                                    <option value={"Agent"}>Agent</option>
                                                    <option value={"Manager"}>Manager</option>
                                                    <option value={"Other"}>Other</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="form-group mb-3">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="flex-shrink-0 flex-first">
                                                    <div className="form-check form-check-inline">
                                                        <label className="form-check-label" htmlFor="save-pass"></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <button type="button" className="btn btn-lg btn-primary fw-medium full-width rounded-2" onClick={(e) => editValidation(e)}>Edit Profile</button>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {
                isOpenForgotPwd &&
                <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
                    <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                        <div className="modal-content" id="registermodal">
                            <span className="mod-close" onClick={() => {
                                setEmail("")
                                setOpenForgotPwd(!isOpenForgotPwd)
                            }}>
                                <span className="svg-icon text-primary svg-icon-2hx">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                        <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                        <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                    </svg>
                                </span>
                            </span>
                            <div className="modal-body">
                                <ForgotPassword setOpenForgotPwd={setOpenForgotPwd} setOpenOTP={setOpenOTP} email={email} setEmail={setEmail} setForgotEmailId={setForgotEmailId} />
                            </div>
                        </div>
                    </div>
                </div>
            }

            {
                isOpenOTP &&
                <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
                    <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                        <div className="modal-content" id="registermodal">
                            <span className="mod-close" onClick={() => {
                                setEmail("")
                                setOTP("")
                                setOpenOTP(!isOpenOTP)
                            }}>
                                <span className="svg-icon text-primary svg-icon-2hx">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                        <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                        <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                    </svg>
                                </span>
                            </span>
                            <div className="modal-body">
                                <OtpModal setOpenOTP={setOpenOTP} email={email} setOpenResetPwd={setOpenResetPwd} otp={otp} setOTP={setOTP} forgotEmailId={forgotEmailId} />
                            </div>
                        </div>
                    </div>
                </div>
            }

            {
                isOpenResetPwd &&
                <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
                    <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                        <div className="modal-content" id="registermodal">
                            <span className="mod-close" onClick={() => {
                                setEmail("")
                                setOTP("")
                                setOpenResetPwd(!isOpenResetPwd)
                            }}>
                                <span className="svg-icon text-primary svg-icon-2hx">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                        <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                        <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                    </svg>
                                </span>
                            </span>
                            <div className="modal-body">
                                <ResetPassword setOpenResetPwd={setOpenResetPwd} email={email} otp={otp} setLogin={setLogin} setForgotEmailId={setForgotEmailId} setOTP={setOTP} forgotEmailId={forgotEmailId} />
                            </div>
                        </div>
                    </div>
                </div>
            }

            {
                createAccount &&
                <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
                    <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                        <div className="modal-content" id="registermodal">
                            <span className="mod-close" onClick={() => setCreateAccount(!createAccount)}>
                                <span className="svg-icon text-primary svg-icon-2hx">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                        <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                        <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                    </svg>
                                </span>
                            </span>
                            <div className="modal-body">
                                <CreateAccount setCreateAccount={setCreateAccount} />
                                <div className="text-center">
                                    <p className="">Already have an account? <Link to="#" className="link fw-medium" onClick={() => {
                                        setCreateAccount(false)
                                        setLogin(true)
                                    }}>Sign in</Link></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }


            <div className={`offcanvas offcanvas-end  ${property ? 'show' : ''}`}>
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvasScrollingLabel">Compare & Selected Property</h5>
                    <Link to="#" onClick={() => setProperty(!property)}>
                        <span className="svg-icon text-primary svg-icon-2hx">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                                <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor" />
                                <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor" />
                            </svg>
                        </span>
                    </Link>
                </div>
                <div className="offcanvas-body">
                    <ul className="nav nav-pills sider_tab mb-3" id="pills-tab" role="tablist">
                        <li className="nav-item">
                            <button className={`nav-link ${activeTab === 1 ? 'active' : ''}`} onClick={() => setActiveTab(1)}>Compare Property</button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${activeTab === 2 ? 'active' : ''}`} onClick={() => setActiveTab(2)}>Saved Property</button>
                        </li>
                    </ul>
                    <div className="tab-content" id="pills-tabContent">
                        <div className={`tab-pane fade ${activeTab === 1 ? 'show active' : ''}`}>
                            <div className="sidebar_featured_property">

                                {navProperty.slice(0, 4).map((item, index) => {
                                    return (
                                        <div className="sides_list_property p-2" key={index}>
                                            <div className="sides_list_property_thumb">
                                                <img src={item.image} className="img-fluid" alt="" />
                                            </div>
                                            <div className="sides_list_property_detail">
                                                <h4><Link to="/single-property-1">{item.title}</Link></h4>
                                                <span className="text-muted-2"><i className="fa-solid fa-location-dot"></i>{item.loction}</span>
                                                <div className="lists_property_price">
                                                    <div className="lists_property_types">
                                                        {item.tag === 'For Sale' && <div className="property_types_vlix sale">For Sale</div>}
                                                        {item.tag === 'For Rent' && <div className="property_types_vlix">For Rent</div>}
                                                        {item.tag === 'For Buy' && <div className="property_types_vlix buy">For Buy</div>}

                                                    </div>
                                                    <div className="lists_property_price_value">
                                                        <h4 className="text-primary">{item.value}</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}

                                <div className="input-group">
                                    <Link to="/compare-property" className="btn btn-light-primary fw-medium full-width">View & Compare</Link>
                                </div>
                            </div>
                        </div>
                        <div className={`tab-pane fade ${activeTab === 2 ? 'show active' : ''}`}>
                            <div className="sidebar_featured_property">
                                {navProperty.slice(4, 8).map((item, index) => {
                                    return (
                                        <div className="sides_list_property p-2" key={index}>
                                            <div className="sides_list_property_thumb">
                                                <img src={item.image} className="img-fluid" alt="" />
                                            </div>
                                            <div className="sides_list_property_detail">
                                                <h4><Link to="/single-property-1">{item.title}</Link></h4>
                                                <span className="text-muted-2"><i className="fa-solid fa-location-dot"></i>{item.loction}</span>
                                                <div className="lists_property_price">
                                                    <div className="lists_property_types">
                                                        {item.tag === 'For Sale' && <div className="property_types_vlix sale">For Sale</div>}
                                                        {item.tag === 'For Rent' && <div className="property_types_vlix">For Rent</div>}
                                                        {item.tag === 'For Buy' && <div className="property_types_vlix buy">For Buy</div>}
                                                    </div>
                                                    <div className="lists_property_price_value">
                                                        <h4 className="text-primary">{item.value}</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                                <div className="input-group">
                                    <Link to="#" className="btn btn-light-primary fw-medium full-width">View & Compare</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
